module.exports = __webpack_public_path__ + "img/COVID-19-Livelihood-1110x450.814e8b25.png";